/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loading-start': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M4.44 5.023h2.435v2.435H4.44zM.826 7.478h9.73M2.005.579H4.44v2.435H2.005z"/><path pid="1" d="M6.872 5.023h2.435v2.435H6.872zM6.872 2.588h2.435v2.435H6.872z"/></g>'
  }
})
